interface TipoProduto {
  value: string;
  label: string;
}

let TiposProduto: TipoProduto[] = [
  { value: 'CARTAO_BENEFICIO', label: 'Cartão Benefício' },
  { value: 'ANTECIPACAO_REMUNERACAO', label: 'Antecipação de Remuneração' },
  { value: 'CARTAO_CREDITO', label: 'Cartão Crédito' },
  { value: 'EMPRESTIMO', label: 'Empréstimo' },
];

const { REACT_APP_PERFIL } = process.env;

TiposProduto = REACT_APP_PERFIL === 'QISTA'
  ? TiposProduto.filter(p => p.value !== 'ANTECIPACAO_REMUNERACAO')
  : TiposProduto;

const getLabelTipoProduto = (value: string | undefined): string => {
  if (!value) return '-';
  const tipoProduto = TiposProduto.find(prod => prod.value === value);
  return tipoProduto?.label || value;
};

export const EnumTipoProduto = {
  CARTAO_BENEFICIO: 'CARTAO_BENEFICIO',
  ANTECIPACAO_REMUNERACAO: 'ANTECIPACAO_REMUNERACAO',
  CARTAO_CREDITO: 'CARTAO_CREDITO',
  EMPRESTIMO: 'EMPRESTIMO',
} as const;

export type TipoProdutoValues = keyof typeof EnumTipoProduto; // opcional, só se quiser usar tipo

export { TiposProduto, getLabelTipoProduto };
